// @generated
import { PapiDeviation } from '@wix/da-papi-types';

// source: browse > statuses
export const statuses: PapiDeviation[] = [
  {
    deviationId: 914573653,
    type: 'status',
    typeId: 81,
    url: 'https://www.deviantart.com/reactortest3/status-update/Untitled-914573653',
    title: 'Untitled',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-04-29T10:20:16-0700',
    isTextEditable: true,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    blockReasons: [],
    author: {
      userId: 22458021,
      useridUuid: 'b3540b02-bfc5-4685-87bf-68dccb658bd5',
      username: 'reactortest3',
      usericon: 'https://a.deviantart.net/avatars-big/r/e/reactortest3.jpg?14',
      type: 'core_access',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 1,
      views: 185,
      downloads: 0,
    },
    media: {
      types: [],
    },
    textContent: {
      excerpt: ' ',
      html: {
        type: 'draft',
        features:
          '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emoji":0,"emotes":0,"images":0,"mentions":0,"video":1,"previews":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":0,"chars":1}}]',
      },
    },
  },
  {
    deviationId: 858245823,
    type: 'status',
    typeId: 1,
    url: 'https://www.deviantart.lan/muteor/status-update/Untitled-858245823',
    title: 'Untitled',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    publishedTime: '2020-10-26T04:23:34-0700',
    isTextEditable: true,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    hasPrivateComments: false,
    blockReasons: [],
    author: {
      userId: 19960677,
      useridUuid: 'f0b54843-a4a5-49ef-9f81-35d75c7a1c1d',
      username: 'muteor',
      usericon: 'https://a.deviantart.net/avatars-big/m/u/muteor.jpg?12',
      type: 'admin',
      isWatching: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    media: {
      types: [],
    },
    textContent: {
      excerpt: 'asdasd',
      html: {
        type: 'draft',
        markup:
          '{"blocks":[{"key":"foo","text":"test","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
        features:
          '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":1,"chars":4}}]',
      },
    },
  },
  {
    deviationId: 19610311,
    typeId: 69,
    url: 'https://www.deviantart.com/cheath18/status-update/19610311',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:22:45-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 40758937,
      useridUuid: '1633d1ce-aacc-4019-b3c7-f4b395750b54',
      username: 'cheath18',
      usericon: 'https://a.deviantart.net/avatars-big/c/h/cheath18.png?4',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    status: {
      statusId: 19610311,
      ts: '2020-01-07T04:22:45-0800',
      url: 'https://www.deviantart.com/cheath18/status-update/19610311',
      commentsCount: 0,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 40758937,
        useridUuid: '1633d1ce-aacc-4019-b3c7-f4b395750b54',
        username: 'cheath18',
        usericon: 'https://a.deviantart.net/avatars-big/c/h/cheath18.png?4',
        type: 'regular',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt:
        'Anyone want to do a WWE RP with me the rules are in my latest journal entry.\nif interested comment on this or send me a note',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 19610310,
    typeId: 69,
    url: 'https://www.deviantart.com/zenomezz/status-update/19610310',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:22:34-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 4207384,
      useridUuid: '51005548-3b23-4d21-9b20-69ee25eb2da4',
      username: 'Zenomezz',
      usericon: 'https://a.deviantart.net/avatars-big/z/e/zenomezz.jpg?2',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    status: {
      statusId: 19610310,
      ts: '2020-01-07T04:22:34-0800',
      url: 'https://www.deviantart.com/zenomezz/status-update/19610310',
      commentsCount: 0,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 4207384,
        useridUuid: '51005548-3b23-4d21-9b20-69ee25eb2da4',
        username: 'Zenomezz',
        usericon: 'https://a.deviantart.net/avatars-big/z/e/zenomezz.jpg?2',
        type: 'regular',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt: 'What a dreadful fucking morning',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 19610309,
    typeId: 69,
    url: 'https://www.deviantart.com/amywolfx3/status-update/19610309',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:22:10-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 47958877,
      useridUuid: '5a4dfaa1-b4b6-44c6-8a37-7a3b34e42177',
      username: 'amywolfX3',
      usericon: 'https://a.deviantart.net/avatars-big/a/m/amywolfx3.jpg?10',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    status: {
      statusId: 19610309,
      ts: '2020-01-07T04:22:10-0800',
      url: 'https://www.deviantart.com/amywolfx3/status-update/19610309',
      commentsCount: 0,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 47958877,
        useridUuid: '5a4dfaa1-b4b6-44c6-8a37-7a3b34e42177',
        username: 'amywolfX3',
        usericon: 'https://a.deviantart.net/avatars-big/a/m/amywolfx3.jpg?10',
        type: 'regular',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt: 'I feel like braking down right now',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 19610308,
    typeId: 69,
    url: 'https://www.deviantart.com/ahmadsoftware786/status-update/19610308',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:21:44-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 50723707,
      useridUuid: '4469e789-92f9-46f7-9297-f702ea753a93',
      username: 'ahmadsoftware786',
      usericon:
        'https://a.deviantart.net/avatars-big/a/h/ahmadsoftware786.jpg?2',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    status: {
      statusId: 19610308,
      ts: '2020-01-07T04:21:44-0800',
      url: 'https://www.deviantart.com/ahmadsoftware786/status-update/19610308',
      commentsCount: 0,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 50723707,
        useridUuid: '4469e789-92f9-46f7-9297-f702ea753a93',
        username: 'ahmadsoftware786',
        usericon:
          'https://a.deviantart.net/avatars-big/a/h/ahmadsoftware786.jpg?2',
        type: 'regular',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt:
        'How To Scrape or Download Leads Data From Google Maps Search Results?\nQuickly find useful data including names, emails, phone numbers, and social media links to create really working lists! Google Map Extractor collects leads from Google Maps includ',
      html: {
        type: 'draft',
        features:
          '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":39,"chars":249}}]',
      },
    },
  },
  {
    deviationId: 19610307,
    typeId: 69,
    url: 'https://www.deviantart.com/actionyuri/status-update/19610307',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:21:20-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 37297199,
      useridUuid: 'ee93a00e-8c6e-47cc-94f9-41b5b18d80c1',
      username: 'ActionYuri',
      usericon: 'https://a.deviantart.net/avatars-big/a/c/actionyuri.gif?11',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    status: {
      statusId: 19610307,
      ts: '2020-01-07T04:21:20-0800',
      url: 'https://www.deviantart.com/actionyuri/status-update/19610307',
      commentsCount: 0,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 37297199,
        useridUuid: 'ee93a00e-8c6e-47cc-94f9-41b5b18d80c1',
        username: 'ActionYuri',
        usericon: 'https://a.deviantart.net/avatars-big/a/c/actionyuri.gif?11',
        type: 'regular',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt:
        "I finally found a song that I listened to a year ago or something, I feel like it doesn't have enough love, even if for me it's a masterpiece, so I'll just drop it here cause I respect this one.",
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 19610306,
    typeId: 69,
    url: 'https://www.deviantart.com/brokennooby64/status-update/19610306',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:21:09-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 37423945,
      useridUuid: '15f48222-b183-429d-b04d-411253d1da27',
      username: 'BrokenNooby64',
      usericon: 'https://a.deviantart.net/avatars-big/b/r/brokennooby64.png?15',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    status: {
      statusId: 19610306,
      ts: '2020-01-07T04:21:09-0800',
      url: 'https://www.deviantart.com/brokennooby64/status-update/19610306',
      commentsCount: 0,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 37423945,
        useridUuid: '15f48222-b183-429d-b04d-411253d1da27',
        username: 'BrokenNooby64',
        usericon:
          'https://a.deviantart.net/avatars-big/b/r/brokennooby64.png?15',
        type: 'regular',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt:
        'Consider this, folks: A Revamp of my past characters: Garrus, Kira, Jason, Alice, and Ki?',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 19610305,
    typeId: 69,
    url: 'https://www.deviantart.com/breabearjones/status-update/19610305',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:20:51-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 44495530,
      useridUuid: 'bddc59cd-8b99-4c51-99b5-6a437d2220a0',
      username: 'BreaBearJones',
      usericon: 'https://a.deviantart.net/avatars-big/b/r/breabearjones.jpg?12',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    status: {
      statusId: 19610305,
      ts: '2020-01-07T04:20:51-0800',
      url: 'https://www.deviantart.com/breabearjones/status-update/19610305',
      commentsCount: 0,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 44495530,
        useridUuid: 'bddc59cd-8b99-4c51-99b5-6a437d2220a0',
        username: 'BreaBearJones',
        usericon:
          'https://a.deviantart.net/avatars-big/b/r/breabearjones.jpg?12',
        type: 'regular',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt:
        'Went shopping for trios !!! 😉💐💐\n\nhttps://youtu.be/lHrH7K2UyjM#breeonijones #breabearjones #shopping #shoppingtime #shoppingcart #kleancolor #kleancolorhaul #haul #YouTube #youtuber #youtubevideo #youtubers #youtubechannel',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 19610304,
    typeId: 69,
    url: 'https://www.deviantart.com/stormtrooper1223/status-update/19610304',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:20:23-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 50064140,
      useridUuid: 'c6812629-50c4-4d23-81bb-0d19d410e038',
      username: 'stormtrooper1223',
      usericon:
        'https://a.deviantart.net/avatars-big/s/t/stormtrooper1223.jpg?8',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    status: {
      statusId: 19610304,
      ts: '2020-01-07T04:20:23-0800',
      url: 'https://www.deviantart.com/stormtrooper1223/status-update/19610304',
      commentsCount: 0,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 50064140,
        useridUuid: 'c6812629-50c4-4d23-81bb-0d19d410e038',
        username: 'stormtrooper1223',
        usericon:
          'https://a.deviantart.net/avatars-big/s/t/stormtrooper1223.jpg?8',
        type: 'regular',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt:
        "@KatiAmel? Could you please respond to me? I'm getting worried about you right now, sis.",
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 19610303,
    typeId: 69,
    url: 'https://www.deviantart.com/707fangirl/status-update/19610303',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:20:17-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 38407957,
      useridUuid: '5f7ed1cf-02fc-45a5-ae86-2e0f8482629d',
      username: '707Fangirl',
      usericon: 'https://a.deviantart.net/avatars-big/7/0/707fangirl.jpg?5',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    status: {
      statusId: 19610303,
      ts: '2020-01-07T04:20:17-0800',
      url: 'https://www.deviantart.com/707fangirl/status-update/19610303',
      commentsCount: 0,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 38407957,
        useridUuid: '5f7ed1cf-02fc-45a5-ae86-2e0f8482629d',
        username: '707Fangirl',
        usericon: 'https://a.deviantart.net/avatars-big/7/0/707fangirl.jpg?5',
        type: 'regular',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt:
        'Confession: I want my Dubwool to yeet Chairman Rose into space.',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 19610302,
    typeId: 69,
    url: 'https://www.deviantart.com/tardisghost/status-update/19610302',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:19:16-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 46140117,
      useridUuid: '08dc5673-6005-4fa8-b302-66b573530923',
      username: 'TardisGhost',
      usericon: 'https://a.deviantart.net/avatars-big/t/a/tardisghost.gif?10',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    status: {
      statusId: 19610302,
      ts: '2020-01-07T04:19:16-0800',
      url: 'https://www.deviantart.com/tardisghost/status-update/19610302',
      commentsCount: 0,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 46140117,
        useridUuid: '08dc5673-6005-4fa8-b302-66b573530923',
        username: 'TardisGhost',
        usericon: 'https://a.deviantart.net/avatars-big/t/a/tardisghost.gif?10',
        type: 'regular',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt:
        'Spoilers ahead for newest Doctor Who season! (You have been warned)..........\nI have to say, Dhawan seemed super unfitting for the Master role in the first episode... but after the second? Gosh, he\'s awesome! xD Those outfits were really sexy on him, <a href="https://www.deviantart.com/tardisghost/status-update/19610302">...</a>',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 19610301,
    typeId: 69,
    url: 'https://www.deviantart.com/xxstarrypuffydreamxx/status-update/19610301',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:19:00-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 32115545,
      useridUuid: '31dd195e-41d5-4cd1-ba9a-7e79bdf55a71',
      username: 'xXStarryPuffyDreamXx',
      usericon:
        'https://a.deviantart.net/avatars-big/x/x/xxstarrypuffydreamxx.png?10',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    status: {
      statusId: 19610301,
      ts: '2020-01-07T04:19:00-0800',
      url: 'https://www.deviantart.com/xxstarrypuffydreamxx/status-update/19610301',
      commentsCount: 0,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 32115545,
        useridUuid: '31dd195e-41d5-4cd1-ba9a-7e79bdf55a71',
        username: 'xXStarryPuffyDreamXx',
        usericon:
          'https://a.deviantart.net/avatars-big/x/x/xxstarrypuffydreamxx.png?10',
        type: 'premium',
        isNewDeviant: false,
      },
      items: [
        {
          type: 'thumb_background_deviation',
          deviation: {
            deviationId: 826113570,
            typeId: 1,
            url: 'https://www.deviantart.com/acerbase12/art/Pontiki-Opening-Raffle-826113570',
            title: 'Pontiki Opening Raffle',
            isJournal: false,
            isPurchasable: false,
            publishedTime: '2020-01-07T04:02:35-0800',
            isTextEditable: false,
            legacyTextEditUrl: null,
            isShareable: true,
            isCommentable: true,
            isFavourited: false,
            isDeleted: false,
            isMature: false,
            isDownloadable: false,
            isAntisocial: false,
            isBlocked: false,
            isPublished: true,
            blockReasons: [],
            author: {
              userId: 46137601,
              useridUuid: '947a047f-54ba-4d84-a8d6-c18faf3da8d8',
              username: 'acerbase12',
              usericon:
                'https://a.deviantart.net/avatars-big/a/c/acerbase12.png?4',
              type: 'regular',
              isNewDeviant: false,
            },
            stats: {
              comments: 0,
              favourites: 1,
            },
            media: {
              baseUri:
                'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/947a047f-54ba-4d84-a8d6-c18faf3da8d8/ddnuhb6-5b8ef0d5-ac31-4f49-a271-1fdf19048944.png',
              prettyName: 'pontiki_opening_raffle_by_acerbase12_ddnuhb6',
              token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTQ2IiwicGF0aCI6IlwvZlwvOTQ3YTA0N2YtNTRiYS00ZDg0LWE4ZDYtYzE4ZmFmM2RhOGQ4XC9kZG51aGI2LTViOGVmMGQ1LWFjMzEtNGY0OS1hMjcxLTFmZGYxOTA0ODk0NC5wbmciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.hbVkY71K5we_EBW05r3eKLakAky-TvAaSHsojzDvOwE',
              ],
              types: [
                {
                  t: '150',
                  r: 0,
                  c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                  h: 64,
                  w: 150,
                  o: true,
                },
                {
                  t: '200H',
                  r: 0,
                  c: 'v1/fill/w_300,h_128,strp/<prettyName>-200h.png',
                  h: 128,
                  w: 300,
                  o: true,
                },
                {
                  t: '300W',
                  r: 0,
                  c: 'v1/fit/w_300,h_546,strp/<prettyName>-300w.png',
                  h: 128,
                  w: 300,
                  o: true,
                },
                {
                  t: '250T',
                  r: 0,
                  c: 'v1/fill/w_500,h_213,strp/<prettyName>-250t.png',
                  h: 213,
                  w: 500,
                  o: true,
                },
                {
                  t: '350T',
                  r: 0,
                  c: 'v1/fill/w_700,h_298,strp/<prettyName>-350t.png',
                  h: 299,
                  w: 700,
                  o: true,
                },
                {
                  t: '400T',
                  r: 0,
                  c: 'v1/fill/w_800,h_341,strp/<prettyName>-400t.png',
                  h: 341,
                  w: 800,
                  o: true,
                },
                {
                  t: 'preview',
                  r: 0,
                  c: 'v1/fill/w_1280,h_546,strp/<prettyName>-fullview.png',
                  h: 546,
                  w: 1280,
                  o: true,
                  f: 2111653,
                },
                {
                  t: 'social_preview',
                  r: 0,
                  c: 'v1/fill/w_1280,h_546,strp/<prettyName>-fullview.png',
                  h: 546,
                  w: 1280,
                  o: true,
                },
                {
                  t: 'fullview',
                  r: 0,
                  c: 'v1/fill/w_1280,h_546,strp/<prettyName>-fullview.png',
                  h: 546,
                  w: 1280,
                  o: true,
                  f: 2111653,
                },
              ],
            },
          },
        },
      ],
    },
    textContent: {
      excerpt: 'pstt, look at this!\njoin us!~',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 19610300,
    typeId: 69,
    url: 'https://www.deviantart.com/misf0rtunate/status-update/19610300',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:18:37-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 41292504,
      useridUuid: '02a7d020-b470-47f3-8f6c-6994f89270bf',
      username: 'MISF0RTUNATE',
      usericon: 'https://a.deviantart.net/avatars-big/m/i/misf0rtunate.png?9',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 1,
      favourites: 0,
    },
    status: {
      statusId: 19610300,
      ts: '2020-01-07T04:18:37-0800',
      url: 'https://www.deviantart.com/misf0rtunate/status-update/19610300',
      commentsCount: 1,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 41292504,
        useridUuid: '02a7d020-b470-47f3-8f6c-6994f89270bf',
        username: 'MISF0RTUNATE',
        usericon: 'https://a.deviantart.net/avatars-big/m/i/misf0rtunate.png?9',
        type: 'premium',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt:
        'tfw you wanna commission someone but they take paypal only and you only have points so PERISH ',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 19610299,
    typeId: 69,
    url: 'https://www.deviantart.com/retroneb/status-update/19610299',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:18:32-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 27873568,
      useridUuid: 'f3e6bdcd-ab5c-4528-b4f9-7c9827d9145a',
      username: 'RetroNeb',
      usericon: 'https://a.deviantart.net/avatars-big/r/e/retroneb.gif?13',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    status: {
      statusId: 19610299,
      ts: '2020-01-07T04:18:32-0800',
      url: 'https://www.deviantart.com/retroneb/status-update/19610299',
      commentsCount: 0,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 27873568,
        useridUuid: 'f3e6bdcd-ab5c-4528-b4f9-7c9827d9145a',
        username: 'RetroNeb',
        usericon: 'https://a.deviantart.net/avatars-big/r/e/retroneb.gif?13',
        type: 'regular',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt: 'is it safe to cryyy??',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 19610298,
    typeId: 69,
    url: 'https://www.deviantart.com/retroneb/status-update/19610298',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:18:03-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 27873568,
      useridUuid: 'f3e6bdcd-ab5c-4528-b4f9-7c9827d9145a',
      username: 'RetroNeb',
      usericon: 'https://a.deviantart.net/avatars-big/r/e/retroneb.gif?13',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    status: {
      statusId: 19610298,
      ts: '2020-01-07T04:18:03-0800',
      url: 'https://www.deviantart.com/retroneb/status-update/19610298',
      commentsCount: 0,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 27873568,
        useridUuid: 'f3e6bdcd-ab5c-4528-b4f9-7c9827d9145a',
        username: 'RetroNeb',
        usericon: 'https://a.deviantart.net/avatars-big/r/e/retroneb.gif?13',
        type: 'regular',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt: 'I couldnt sleep all night and now my head is throbbing :/',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 19610297,
    typeId: 69,
    url: 'https://www.deviantart.com/jdxdcbest/status-update/19610297',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:16:51-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 38006355,
      useridUuid: '5306b606-9a21-405b-9377-7dded65b2482',
      username: 'JDXDCBest',
      usericon: 'https://a.deviantart.net/avatars-big/j/d/jdxdcbest.jpg?13',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    status: {
      statusId: 19610297,
      ts: '2020-01-07T04:16:51-0800',
      url: 'https://www.deviantart.com/jdxdcbest/status-update/19610297',
      commentsCount: 0,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 38006355,
        useridUuid: '5306b606-9a21-405b-9377-7dded65b2482',
        username: 'JDXDCBest',
        usericon: 'https://a.deviantart.net/avatars-big/j/d/jdxdcbest.jpg?13',
        type: 'premium',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt: "It's my birthday, y'all!",
      html: {
        type: 'draft',
        features:
          '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":0,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":4,"chars":24}}]',
      },
    },
  },
  {
    deviationId: 19610296,
    typeId: 69,
    url: 'https://www.deviantart.com/nandmgachastudio/status-update/19610296',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:15:57-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 48308485,
      useridUuid: 'baa99e9b-649e-40cb-9b86-51d45cf86184',
      username: 'NandMGachaStudio',
      usericon:
        'https://a.deviantart.net/avatars-big/n/a/nandmgachastudio.png?14',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 2,
      favourites: 0,
    },
    status: {
      statusId: 19610296,
      ts: '2020-01-07T04:15:57-0800',
      url: 'https://www.deviantart.com/nandmgachastudio/status-update/19610296',
      commentsCount: 2,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 48308485,
        useridUuid: 'baa99e9b-649e-40cb-9b86-51d45cf86184',
        username: 'NandMGachaStudio',
        usericon:
          'https://a.deviantart.net/avatars-big/n/a/nandmgachastudio.png?14',
        type: 'regular',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt: 'almost at 70 watchers (o⌒∇⌒o)',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 19610295,
    typeId: 69,
    url: 'https://www.deviantart.com/littler0bin/status-update/19610295',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:15:45-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 48131160,
      useridUuid: '2287be15-500c-4ec4-88f0-f0b4d8bab502',
      username: 'LittleR0bin',
      usericon: 'https://a.deviantart.net/avatars-big/l/i/littler0bin.gif?4',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    status: {
      statusId: 19610295,
      ts: '2020-01-07T04:15:45-0800',
      url: 'https://www.deviantart.com/littler0bin/status-update/19610295',
      commentsCount: 0,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 48131160,
        useridUuid: '2287be15-500c-4ec4-88f0-f0b4d8bab502',
        username: 'LittleR0bin',
        usericon: 'https://a.deviantart.net/avatars-big/l/i/littler0bin.gif?4',
        type: 'premium',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt:
        'Haha update: we just got our boarding group number for Rise of the Resistance. I’ll update ya’ll when I get on and off the ride, or experience. I forget what it is. But it’s StarWars so, it’s gotta be good.',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 19610294,
    typeId: 69,
    url: 'https://www.deviantart.com/butt3r-sc0tch/status-update/19610294',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:15:36-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 50107147,
      useridUuid: '6e5f76ed-823e-485a-ac23-b1c2da882e79',
      username: 'BUTT3R-SC0TCH',
      usericon: 'https://a.deviantart.net/avatars-big/b/u/butt3r-sc0tch.jpg?2',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    status: {
      statusId: 19610294,
      ts: '2020-01-07T04:15:36-0800',
      url: 'https://www.deviantart.com/butt3r-sc0tch/status-update/19610294',
      commentsCount: 0,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 50107147,
        useridUuid: '6e5f76ed-823e-485a-ac23-b1c2da882e79',
        username: 'BUTT3R-SC0TCH',
        usericon:
          'https://a.deviantart.net/avatars-big/b/u/butt3r-sc0tch.jpg?2',
        type: 'regular',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt: 'am off to school goodbye\n\nim nervous',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 19610293,
    typeId: 69,
    url: 'https://www.deviantart.com/hypodriive/status-update/19610293',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:15:27-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 30471140,
      useridUuid: '0d5b0b48-b4e0-41b9-9414-faa78eeccf91',
      username: 'hypodriive',
      usericon: 'https://a.deviantart.net/avatars-big/h/y/hypodriive.png?5',
      type: 'beta',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    status: {
      statusId: 19610293,
      ts: '2020-01-07T04:15:27-0800',
      url: 'https://www.deviantart.com/hypodriive/status-update/19610293',
      commentsCount: 0,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 30471140,
        useridUuid: '0d5b0b48-b4e0-41b9-9414-faa78eeccf91',
        username: 'hypodriive',
        usericon: 'https://a.deviantart.net/avatars-big/h/y/hypodriive.png?5',
        type: 'beta',
        isNewDeviant: false,
      },
      items: [
        {
          type: 'thumb_background_deviation',
          deviation: {
            deviationId: 824202693,
            typeId: 1,
            url: 'https://www.deviantart.com/hypodriive/art/AT-spaceKnightz-824202693',
            title: 'AT | spaceKnightz',
            isJournal: false,
            isPurchasable: false,
            publishedTime: '2019-12-21T03:11:58-0800',
            isTextEditable: false,
            legacyTextEditUrl: null,
            isShareable: true,
            isCommentable: true,
            isFavourited: false,
            isDeleted: false,
            isMature: false,
            isDownloadable: false,
            isAntisocial: false,
            isBlocked: false,
            isPublished: true,
            blockReasons: [],
            author: {
              userId: 30471140,
              useridUuid: '0d5b0b48-b4e0-41b9-9414-faa78eeccf91',
              username: 'hypodriive',
              usericon:
                'https://a.deviantart.net/avatars-big/h/y/hypodriive.png?5',
              type: 'beta',
              isNewDeviant: false,
            },
            stats: {
              comments: 1,
              favourites: 23,
            },
            media: {
              baseUri:
                'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/0d5b0b48-b4e0-41b9-9414-faa78eeccf91/ddmpiv9-ab50b7eb-339e-4f00-9b80-bdf8ecb1af88.png',
              prettyName: 'at___spaceknightz_by_hypodriive_ddmpiv9',
              token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MzczIiwicGF0aCI6IlwvZlwvMGQ1YjBiNDgtYjRlMC00MWI5LTk0MTQtZmFhNzhlZWNjZjkxXC9kZG1waXY5LWFiNTBiN2ViLTMzOWUtNGYwMC05YjgwLWJkZjhlY2IxYWY4OC5wbmciLCJ3aWR0aCI6Ijw9MzIwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.qmFCQ_P2mEHRBkYIPV4sPxw_7SINCgNSWSnX4CCtW0Q',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzBkNWIwYjQ4LWI0ZTAtNDFiOS05NDE0LWZhYTc4ZWVjY2Y5MVwvZGRtcGl2OS1hYjUwYjdlYi0zMzllLTRmMDAtOWI4MC1iZGY4ZWNiMWFmODgucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.T1hR3Cd_ZhXDIBoWX9X1WsjrabZyOcooXDIEEUBhjo0',
              ],
              types: [
                {
                  t: '150',
                  r: 0,
                  c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                  h: 150,
                  w: 129,
                  o: true,
                },
                {
                  t: '200H',
                  r: 0,
                  c: 'v1/fill/w_172,h_200,strp/<prettyName>-200h.png',
                  h: 200,
                  w: 172,
                  o: true,
                },
                {
                  t: '300W',
                  r: 0,
                  c: 'v1/fit/w_300,h_373,strp/<prettyName>-300w.png',
                  h: 350,
                  w: 300,
                  o: true,
                },
                {
                  t: '250T',
                  r: 0,
                  c: 'v1/crop/w_214,h_250,x_0,y_0,scl_0.671875,strp/<prettyName>-250t.png',
                  h: 250,
                  w: 214,
                  o: true,
                },
                {
                  t: '350T',
                  r: 0,
                  c: 'v1/fill/w_300,h_350,strp/<prettyName>-350t.png',
                  h: 350,
                  w: 300,
                  o: true,
                },
                {
                  t: '400T',
                  r: 0,
                  c: 'v1/fill/w_320,h_373,strp/<prettyName>-fullview.png',
                  h: 373,
                  w: 320,
                  o: true,
                },
                {
                  t: 'preview',
                  r: 0,
                  c: 'v1/fill/w_320,h_373,strp/<prettyName>-fullview.png',
                  h: 373,
                  w: 320,
                  o: true,
                  f: 70971,
                },
                {
                  t: 'social_preview',
                  r: 0,
                  c: 'v1/fill/w_320,h_373,strp/<prettyName>-fullview.png',
                  h: 373,
                  w: 320,
                  o: true,
                },
                {
                  t: 'fullview',
                  r: 1,
                  h: 373,
                  w: 320,
                  o: true,
                  f: 70971,
                },
              ],
            },
          },
        },
      ],
    },
    textContent: {
      excerpt: 'will do a fullbody pagedoll for 3 months core \nfcfs',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 19610292,
    typeId: 69,
    url: 'https://www.deviantart.com/bakery-meat/status-update/19610292',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:15:25-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 42880744,
      useridUuid: 'a51c685f-800c-4efd-af43-fca46c80c625',
      username: 'BAKERY-MEAT',
      usericon: 'https://a.deviantart.net/avatars-big/b/a/bakery-meat.png?15',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    status: {
      statusId: 19610292,
      ts: '2020-01-07T04:15:25-0800',
      url: 'https://www.deviantart.com/bakery-meat/status-update/19610292',
      commentsCount: 0,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 42880744,
        useridUuid: 'a51c685f-800c-4efd-af43-fca46c80c625',
        username: 'BAKERY-MEAT',
        usericon: 'https://a.deviantart.net/avatars-big/b/a/bakery-meat.png?15',
        type: 'regular',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt:
        "Baby boy baby needs a better name than the one I had \nhttps://toyhou.se/5747813.tbn\nI'm making a suit out of him instead! I love him so much!!\nSmol party hat horns!",
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 19610291,
    typeId: 69,
    url: 'https://www.deviantart.com/simrankaur97616/status-update/19610291',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:14:55-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 52047139,
      useridUuid: 'c13353f5-8271-4861-b554-67580ab83244',
      username: 'simrankaur97616',
      usericon: 'https://a.deviantart.net/avatars-big/default.gif',
      usericonDefault: true,
      type: 'regular',
      isNewDeviant: true,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    status: {
      statusId: 19610291,
      ts: '2020-01-07T04:14:55-0800',
      url: 'https://www.deviantart.com/simrankaur97616/status-update/19610291',
      commentsCount: 0,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 52047139,
        useridUuid: 'c13353f5-8271-4861-b554-67580ab83244',
        username: 'simrankaur97616',
        usericon: 'https://a.deviantart.net/avatars-big/default.gif',
        usericonDefault: true,
        type: 'regular',
        isNewDeviant: true,
      },
      items: [],
    },
    textContent: {
      excerpt:
        " \n \nWHAT is a popular pop and blues-rock band delivering the best of 'what' you will ever hear of these genres!\nBook Live bands in Delhi at https://starclinch.com/book-band-online",
      html: {
        type: 'draft',
        features:
          '[{"type":"FIRST_IMAGE_FEATURE","data":{"deviation":{"deviationId":2471457567534875,"typeId":1,"url":"https:\\/\\/www.deviantart.com\\/simrankaur97616\\/art\\/What1-826146245","title":"What1","isJournal":false,"isPurchasable":false,"publishedTime":"2020-01-07T04:14:37-0800","isShareable":true,"isCommentable":true,"isFavourited":false,"isDeleted":false,"isMature":false,"isDownloadable":true,"isAntisocial":false,"isBlocked":false,"isPublished":false,"author":{"userId":52047139,"useridUuid":"c13353f5-8271-4861-b554-67580ab83244","username":"simrankaur97616","usericon":"https:\\/\\/a.deviantart.net\\/avatars-big\\/default.gif","usericonDefault":true,"type":"regular","isNewDeviant":true},"media":{"baseUri":"https:\\/\\/images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com\\/f\\/c13353f5-8271-4861-b554-67580ab83244\\/ddnv6it-61da4bf1-a157-4165-8c15-c0b29a2f4a71.jpg","prettyName":"what1_by_simrankaur97616_ddnv6it","token":["eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTA4MCIsInBhdGgiOiJcL2ZcL2MxMzM1M2Y1LTgyNzEtNDg2MS1iNTU0LTY3NTgwYWI4MzI0NFwvZGRudjZpdC02MWRhNGJmMS1hMTU3LTQxNjUtOGMxNS1jMGIyOWEyZjRhNzEuanBnIiwid2lkdGgiOiI8PTEwODAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.I7mePexD2WWvexAnMzEfKzXUhKtDr_kWTWMVOogPikI","eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2MxMzM1M2Y1LTgyNzEtNDg2MS1iNTU0LTY3NTgwYWI4MzI0NFwvZGRudjZpdC02MWRhNGJmMS1hMTU3LTQxNjUtOGMxNS1jMGIyOWEyZjRhNzEuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.kgc-XDLEsH8kifWxVSZcRSltf4hKIb6mXmTPmA3YmjA"],"types":[{"t":"150","r":0,"c":"v1\\/fit\\/w_150,h_150,q_70,strp\\/<prettyName>-150.jpg","h":150,"w":150},{"t":"200H","r":0,"c":"v1\\/fill\\/w_200,h_200,q_70,strp\\/<prettyName>-200h.jpg","h":200,"w":200},{"t":"300W","r":0,"c":"v1\\/fit\\/w_300,h_900,q_70,strp\\/<prettyName>-300w.jpg","h":300,"w":300},{"t":"250T","r":0,"c":"v1\\/fill\\/w_250,h_250,q_70,strp\\/<prettyName>-250t.jpg","h":250,"w":250},{"t":"350T","r":0,"c":"v1\\/fill\\/w_350,h_350,q_70,strp\\/<prettyName>-350t.jpg","h":350,"w":350},{"t":"400T","r":0,"c":"v1\\/fill\\/w_400,h_400,q_70,strp\\/<prettyName>-400t.jpg","h":400,"w":400},{"t":"preview","r":0,"c":"v1\\/fill\\/w_894,h_894,q_70,strp\\/<prettyName>-pre.jpg","h":894,"w":894,"f":388154},{"t":"social_preview","r":0,"c":"v1\\/fill\\/w_894,h_894,q_70,strp\\/<prettyName>-pre.jpg","h":894,"w":894},{"t":"fullview","r":1,"h":1080,"w":1080,"f":388154}]},"entityId":2471457567534875}}},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":1,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":30,"chars":179}}]',
      },
    },
  },
  {
    deviationId: 19610290,
    typeId: 69,
    url: 'https://www.deviantart.com/707fangirl/status-update/19610290',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:14:43-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 38407957,
      useridUuid: '5f7ed1cf-02fc-45a5-ae86-2e0f8482629d',
      username: '707Fangirl',
      usericon: 'https://a.deviantart.net/avatars-big/7/0/707fangirl.jpg?5',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    status: {
      statusId: 19610290,
      ts: '2020-01-07T04:14:43-0800',
      url: 'https://www.deviantart.com/707fangirl/status-update/19610290',
      commentsCount: 0,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 38407957,
        useridUuid: '5f7ed1cf-02fc-45a5-ae86-2e0f8482629d',
        username: '707Fangirl',
        usericon: 'https://a.deviantart.net/avatars-big/7/0/707fangirl.jpg?5',
        type: 'regular',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt: 'It’s not like I have a crush on Piers or anything. Okay maybe!',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 19610289,
    typeId: 69,
    url: 'https://www.deviantart.com/xsessivemarina/status-update/19610289',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:14:15-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 36813075,
      useridUuid: 'e8faa183-cc71-4845-a955-591f86a99973',
      username: 'XSessiveMarina',
      usericon:
        'https://a.deviantart.net/avatars-big/x/s/xsessivemarina.png?12',
      type: 'beta',
      isNewDeviant: false,
    },
    stats: {
      comments: 1,
      favourites: 0,
    },
    status: {
      statusId: 19610289,
      ts: '2020-01-07T04:14:15-0800',
      url: 'https://www.deviantart.com/xsessivemarina/status-update/19610289',
      commentsCount: 1,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 36813075,
        useridUuid: 'e8faa183-cc71-4845-a955-591f86a99973',
        username: 'XSessiveMarina',
        usericon:
          'https://a.deviantart.net/avatars-big/x/s/xsessivemarina.png?12',
        type: 'beta',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt: "Mu bday is tomorrow y'all ",
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 19610288,
    typeId: 69,
    url: 'https://www.deviantart.com/jynfury14/status-update/19610288',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2020-01-07T04:14:14-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 43264528,
      useridUuid: '73f2d804-967c-46af-a666-fc9a496444e1',
      username: 'JYNFury14',
      usericon: 'https://a.deviantart.net/avatars-big/j/y/jynfury14.gif?11',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    status: {
      statusId: 19610288,
      ts: '2020-01-07T04:14:14-0800',
      url: 'https://www.deviantart.com/jynfury14/status-update/19610288',
      commentsCount: 0,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 43264528,
        useridUuid: '73f2d804-967c-46af-a666-fc9a496444e1',
        username: 'JYNFury14',
        usericon: 'https://a.deviantart.net/avatars-big/j/y/jynfury14.gif?11',
        type: 'premium',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt:
        "Hey guys, I may not be in progress a whole lot cause I have to take tests and I'm gonna feel fried.  \nI promise to get whenever I need to finish complete. \nThank you for your patience.   ",
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
];

// source: da-deviation, author yumeruby, statusid 9
export const statusDeviationsLegacy: PapiDeviation[] = [
  {
    deviationId: 9,
    typeId: 69,
    url: 'https://www.deviantart.com/yumeruby/status-update/9',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2014-06-24T09:26:08-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 224436,
      useridUuid: 'a03c0567-0a8b-409a-9e0a-888fc51877cb',
      username: 'yumeruby',
      usericon: 'https://a.deviantart.net/avatars-big/y/u/yumeruby.png?4',
      type: 'admin',
      isNewDeviant: false,
    },
    stats: {
      comments: 1,
      favourites: 0,
    },
    status: {
      statusId: 9,
      ts: '2014-06-24T09:26:08-0700',
      url: 'https://www.deviantart.com/yumeruby/status-update/9',
      commentsCount: 1,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 224436,
        useridUuid: 'a03c0567-0a8b-409a-9e0a-888fc51877cb',
        username: 'yumeruby',
        usericon: 'https://a.deviantart.net/avatars-big/y/u/yumeruby.png?4',
        type: 'admin',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt: 'I like moose.',
      html: {
        type: 'writer',
        markup: 'I like moose.',
        features: '',
      },
    },
  },
];

// source: da-deviation, author muteor, statusid 15093912
export const statusDeviationsShort: PapiDeviation[] = [
  {
    deviationId: 15093912,
    typeId: 69,
    url: 'https://www.deviantart.com/muteor/status-update/15093912',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2018-10-03T06:08:33-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 19960677,
      useridUuid: 'f0b54843-a4a5-49ef-9f81-35d75c7a1c1d',
      username: 'muteor',
      usericon: 'https://a.deviantart.net/avatars-big/m/u/muteor.jpg?12',
      type: 'admin',
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    status: {
      statusId: 15093912,
      ts: '2018-10-03T06:08:33-0700',
      url: 'https://www.deviantart.com/muteor/status-update/15093912',
      commentsCount: 0,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 19960677,
        useridUuid: 'f0b54843-a4a5-49ef-9f81-35d75c7a1c1d',
        username: 'muteor',
        usericon: 'https://a.deviantart.net/avatars-big/m/u/muteor.jpg?12',
        type: 'admin',
        isNewDeviant: false,
      },
      items: [
        {
          type: 'thumb_background_deviation',
          deviation: {
            deviationId: 326779165,
            typeId: 1,
            url: 'https://www.deviantart.com/muteor/art/Test-326779165',
            title: 'Test',
            isJournal: false,
            isPurchasable: false,
            publishedTime: '2012-09-12T08:35:28-0700',
            isTextEditable: false,
            legacyTextEditUrl: null,
            isShareable: false,
            isCommentable: true,
            isFavourited: false,
            isDeleted: false,
            isMature: false,
            isDownloadable: true,
            isAntisocial: true,
            isBlocked: false,
            isPublished: true,
            blockReasons: [],
            author: {
              userId: 19960677,
              useridUuid: 'f0b54843-a4a5-49ef-9f81-35d75c7a1c1d',
              username: 'muteor',
              usericon:
                'https://a.deviantart.net/avatars-big/m/u/muteor.jpg?12',
              type: 'admin',
              isNewDeviant: false,
            },
            stats: {
              comments: 2,
              favourites: 3,
            },
            media: {
              baseUri:
                'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/f0b54843-a4a5-49ef-9f81-35d75c7a1c1d/d5ek0f1-63aa8ed2-a0eb-4b38-a11f-2eaac89204c1.jpg',
              prettyName: 'test_by_muteor_d5ek0f1',
              token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9Njc1IiwicGF0aCI6IlwvZlwvZjBiNTQ4NDMtYTRhNS00OWVmLTlmODEtMzVkNzVjN2ExYzFkXC9kNWVrMGYxLTYzYWE4ZWQyLWEwZWItNGIzOC1hMTFmLTJlYWFjODkyMDRjMS5qcGciLCJ3aWR0aCI6Ijw9OTAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.usYbcWBRxt-2lFx1vS482EajPrync5O9W12eudCttOM',
              ],
              types: [
                {
                  t: '150',
                  r: 0,
                  c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                  h: 113,
                  w: 150,
                },
                {
                  t: '200H',
                  r: 0,
                  c: 'v1/fill/w_267,h_200,q_70,strp/<prettyName>-200h.jpg',
                  h: 200,
                  w: 267,
                },
                {
                  t: '300W',
                  r: 0,
                  c: 'v1/fit/w_300,h_675,q_70,strp/<prettyName>-300w.jpg',
                  h: 225,
                  w: 300,
                },
                {
                  t: '250T',
                  r: 0,
                  c: 'v1/fill/w_333,h_250,q_70,strp/<prettyName>-250t.jpg',
                  h: 250,
                  w: 333,
                },
                {
                  t: '350T',
                  r: 0,
                  c: 'v1/fill/w_467,h_350,q_70,strp/<prettyName>-350t.jpg',
                  h: 350,
                  w: 467,
                },
                {
                  t: '400T',
                  r: 0,
                  c: 'v1/fill/w_533,h_400,q_70,strp/<prettyName>-400t.jpg',
                  h: 400,
                  w: 533,
                },
                {
                  t: 'preview',
                  r: 0,
                  c: 'v1/fill/w_900,h_675,q_75,strp/<prettyName>-fullview.jpg',
                  h: 675,
                  w: 900,
                  f: 3324416,
                },
                {
                  t: 'social_preview',
                  r: 0,
                  c: 'v1/fill/w_900,h_675,q_75,strp/<prettyName>-fullview.jpg',
                  h: 675,
                  w: 900,
                },
                {
                  t: 'fullview',
                  r: 0,
                  c: 'v1/fill/w_900,h_675,q_75,strp/<prettyName>-fullview.jpg',
                  h: 675,
                  w: 900,
                  f: 3324416,
                },
              ],
            },
          },
        },
      ],
    },
    textContent: {
      excerpt: 'I am a status\n \n',
      html: {
        type: 'draft',
        markup:
          '{"blocks":[{"key":"foo","text":"I am a status","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"ecjr9","text":" ","type":"atomic","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":0,"length":1,"key":0}],"data":{}},{"key":"e322n","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{"0":{"type":"wix-draft-plugin-image","mutability":"IMMUTABLE","data":{"config":{"alignment":"center","size":"content","showTitle":true,"showDescription":true,"key":"ecjr9"},"data":{"url":"https://www.deviantart.com/muteor/art/Test-326779165","title":"Test","author":{"username":"muteor","usericon":"https://a.deviantart.net/avatars/m/u/muteor.png?2","type":"admin","userId":19960677},"files":[{"type":"fullview","src":"https://img00.deviantart.net/64ed/i/2012/256/e/b/test_by_muteor-d5ek0f1.jpg","height":675,"width":900},{"type":"400T","src":"https://t00.deviantart.net/928QDIpqgCkpPkdL_oC6kfcTujI=/800x400/filters:fixed_height(100,100):origin()/pre00/07a7/th/pre/i/2012/256/e/b/test_by_muteor-d5ek0f1.jpg","height":400,"width":533},{"type":"350T","src":"https://t00.deviantart.net/vAe4N43968PBFMfjSp-gpWyIO0Y=/700x350/filters:fixed_height(100,100):origin()/pre00/07a7/th/pre/i/2012/256/e/b/test_by_muteor-d5ek0f1.jpg","height":350,"width":467},{"type":"250T","src":"https://t00.deviantart.net/JfSTMCF3mfoo6N-a27W1Dn6mANg=/500x250/filters:fixed_height(100,100):origin()/pre00/07a7/th/pre/i/2012/256/e/b/test_by_muteor-d5ek0f1.jpg","height":250,"width":333}],"deviationId":326779165,"typeId":1,"isJournal":false,"isShareable":false,"isCommentable":true,"isFavourited":false,"isDeleted":false,"isMature":false,"isDownloadable":true,"isAntisocial":true,"isBlocked":false,"isPublished":true,"loveScore":0}}}}}',
        features:
          '[{"type":"FIRST_IMAGE_FEATURE","data":{"deviation":{"url":"https:\\/\\/www.deviantart.com\\/muteor\\/art\\/Test-326779165","title":"Test","author":{"username":"muteor","usericon":"https:\\/\\/a.deviantart.net\\/avatars\\/m\\/u\\/muteor.png?2","type":"admin","userId":19960677},"files":[{"type":"fullview","src":"https:\\/\\/img00.deviantart.net\\/64ed\\/i\\/2012\\/256\\/e\\/b\\/test_by_muteor-d5ek0f1.jpg","height":675,"width":900},{"type":"400T","src":"https:\\/\\/t00.deviantart.net\\/928QDIpqgCkpPkdL_oC6kfcTujI=\\/800x400\\/filters:fixed_height(100,100):origin()\\/pre00\\/07a7\\/th\\/pre\\/i\\/2012\\/256\\/e\\/b\\/test_by_muteor-d5ek0f1.jpg","height":400,"width":533},{"type":"350T","src":"https:\\/\\/t00.deviantart.net\\/vAe4N43968PBFMfjSp-gpWyIO0Y=\\/700x350\\/filters:fixed_height(100,100):origin()\\/pre00\\/07a7\\/th\\/pre\\/i\\/2012\\/256\\/e\\/b\\/test_by_muteor-d5ek0f1.jpg","height":350,"width":467},{"type":"250T","src":"https:\\/\\/t00.deviantart.net\\/JfSTMCF3mfoo6N-a27W1Dn6mANg=\\/500x250\\/filters:fixed_height(100,100):origin()\\/pre00\\/07a7\\/th\\/pre\\/i\\/2012\\/256\\/e\\/b\\/test_by_muteor-d5ek0f1.jpg","height":250,"width":333}],"deviationId":326779165,"typeId":1,"isJournal":false,"isShareable":false,"isCommentable":true,"isFavourited":false,"isDeleted":false,"isMature":false,"isDownloadable":true,"isAntisocial":true,"isBlocked":false,"isPublished":true,"loveScore":0}}},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":1,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":4,"chars":13}}]',
      },
    },
  },
];

// source: da-deviation, author muteor, statusid 15041145
export const statusDeviationsLong: PapiDeviation[] = [
  {
    deviationId: 15041145,
    typeId: 69,
    url: 'https://www.deviantart.com/muteor/status-update/15041145',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2018-09-28T10:23:24-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 19960677,
      useridUuid: 'f0b54843-a4a5-49ef-9f81-35d75c7a1c1d',
      username: 'muteor',
      usericon: 'https://a.deviantart.net/avatars-big/m/u/muteor.jpg?12',
      type: 'admin',
      isNewDeviant: false,
    },
    stats: {
      comments: 4,
      favourites: 0,
    },
    status: {
      statusId: 15041145,
      ts: '2018-09-28T10:23:24-0700',
      url: 'https://www.deviantart.com/muteor/status-update/15041145',
      commentsCount: 4,
      isShare: false,
      isDeleted: false,
      author: {
        userId: 19960677,
        useridUuid: 'f0b54843-a4a5-49ef-9f81-35d75c7a1c1d',
        username: 'muteor',
        usericon: 'https://a.deviantart.net/avatars-big/m/u/muteor.jpg?12',
        type: 'admin',
        isNewDeviant: false,
      },
      items: [],
    },
    textContent: {
      excerpt:
        'I am a really long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long',
      html: {
        type: 'draft',
        markup:
          '{"blocks":[{"key":"foo","text":"I am a really long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long long status update...","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":114,"length":2701,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"8cq44","text":" ","type":"atomic","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":0,"length":1,"key":0}],"data":{}},{"key":"c7920","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{"0":{"type":"wix-draft-plugin-image","mutability":"IMMUTABLE","data":{"config":{"alignment":"center","size":"content","showTitle":true,"showDescription":true,"key":"8cq44"},"data":{"url":"https://www.deviantart.com/muteor/art/Wet-Dog-280572246","title":"Wet Dog","author":{"username":"muteor","usericon":"https://a.deviantart.net/avatars/m/u/muteor.png?2","type":"admin","userId":19960677},"files":[{"type":"fullview","src":"https://orig00.deviantart.net/011c/f/2012/020/d/4/wet_dog_by_muteor-d4n1mxi.jpg","height":1424,"width":2144},{"type":"social_preview","src":"https://pre00.deviantart.net/f05a/th/pre/f/2012/020/d/4/wet_dog_by_muteor-d4n1mxi.jpg","height":728,"width":1097},{"type":"400T","src":"https://t00.deviantart.net/kKePfZSJdmde6pFkonBeeTFP-7M=/fit-in/800x400/filters:fixed_height(100,100):origin()/pre00/f05a/th/pre/f/2012/020/d/4/wet_dog_by_muteor-d4n1mxi.jpg","height":400,"width":602},{"type":"350T","src":"https://t00.deviantart.net/7xb_8sG2UKmnHGT9-EEEEypTqzM=/fit-in/700x350/filters:fixed_height(100,100):origin()/pre00/f05a/th/pre/f/2012/020/d/4/wet_dog_by_muteor-d4n1mxi.jpg","height":350,"width":527},{"type":"250T","src":"https://t00.deviantart.net/Ut2wk3Riac041KWBg_sbjM9qbh4=/fit-in/500x250/filters:fixed_height(100,100):origin()/pre00/f05a/th/pre/f/2012/020/d/4/wet_dog_by_muteor-d4n1mxi.jpg","height":250,"width":376}],"deviationId":280572246,"typeId":1,"isJournal":false,"isShareable":true,"isCommentable":true,"isFavourited":false,"isDeleted":false,"isMature":false,"isDownloadable":true,"isAntisocial":false,"isBlocked":false,"isPublished":true,"loveScore":0}}}}}',
        features:
          '[{"type":"FIRST_IMAGE_FEATURE","data":{"deviation":{"url":"https:\\/\\/www.deviantart.com\\/muteor\\/art\\/Wet-Dog-280572246","title":"Wet Dog","author":{"username":"muteor","usericon":"https:\\/\\/a.deviantart.net\\/avatars\\/m\\/u\\/muteor.png?2","type":"admin","userId":19960677},"files":[{"type":"fullview","src":"https:\\/\\/orig00.deviantart.net\\/011c\\/f\\/2012\\/020\\/d\\/4\\/wet_dog_by_muteor-d4n1mxi.jpg","height":1424,"width":2144},{"type":"social_preview","src":"https:\\/\\/pre00.deviantart.net\\/f05a\\/th\\/pre\\/f\\/2012\\/020\\/d\\/4\\/wet_dog_by_muteor-d4n1mxi.jpg","height":728,"width":1097},{"type":"400T","src":"https:\\/\\/t00.deviantart.net\\/kKePfZSJdmde6pFkonBeeTFP-7M=\\/fit-in\\/800x400\\/filters:fixed_height(100,100):origin()\\/pre00\\/f05a\\/th\\/pre\\/f\\/2012\\/020\\/d\\/4\\/wet_dog_by_muteor-d4n1mxi.jpg","height":400,"width":602},{"type":"350T","src":"https:\\/\\/t00.deviantart.net\\/7xb_8sG2UKmnHGT9-EEEEypTqzM=\\/fit-in\\/700x350\\/filters:fixed_height(100,100):origin()\\/pre00\\/f05a\\/th\\/pre\\/f\\/2012\\/020\\/d\\/4\\/wet_dog_by_muteor-d4n1mxi.jpg","height":350,"width":527},{"type":"250T","src":"https:\\/\\/t00.deviantart.net\\/Ut2wk3Riac041KWBg_sbjM9qbh4=\\/fit-in\\/500x250\\/filters:fixed_height(100,100):origin()\\/pre00\\/f05a\\/th\\/pre\\/f\\/2012\\/020\\/d\\/4\\/wet_dog_by_muteor-d4n1mxi.jpg","height":250,"width":376}],"deviationId":280572246,"typeId":1,"isJournal":false,"isShareable":true,"isCommentable":true,"isFavourited":false,"isDeleted":false,"isMature":false,"isDownloadable":true,"isAntisocial":false,"isBlocked":false,"isPublished":true,"loveScore":0}}},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emotes":0,"images":1,"mentions":0,"video":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":563,"chars":2815}}]',
      },
    },
  },
];

export const statusDeviationsImageOnly: PapiDeviation[] = [
  {
    deviationId: 888961097,
    type: 'status',
    typeId: 81,
    url: 'https://www.deviantart.com/redcapital3/status-update/Untitled-888961097',
    title: 'Untitled',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-08-16T05:20:46-0700',
    isTextEditable: true,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isPinned: false,
    isDailyDeviation: false,
    hasPrivateComments: false,
    blockReasons: [],
    author: {
      userId: 38167473,
      useridUuid: 'dca77dd8-7533-42d3-9969-7c9cbe87fc0d',
      username: 'redcapital3',
      usericon: 'https://a.deviantart.net/avatars-big/default.gif',
      usericonDefault: true,
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    media: {
      types: [],
    },
    textContent: {
      excerpt: ' ',
      html: {
        type: 'draft',
        features:
          '[{"type":"FIRST_IMAGE_FEATURE","data":{"deviation":{"deviationId":252197816,"type":"image","typeId":1,"url":"https:\\/\\/www.deviantart.com\\/chris\\/art\\/Steep-Slope-Stay-Back-252197816","title":"Steep Slope, Stay Back","isJournal":false,"isVideo":false,"isPurchasable":false,"isFavouritable":true,"publishedTime":"2011-08-10T20:51:35-0700","isShareable":true,"isCommentable":true,"isFavourited":false,"isDeleted":false,"isMature":false,"isDownloadable":true,"isAntisocial":false,"isBlocked":false,"isPublished":true,"isDailyDeviation":false,"hasPrivateComments":false,"author":{"userId":3,"useridUuid":"178e6afa-0f9b-4ef0-bb15-47dadfa0e470","username":"chris","usericon":"https:\\/\\/a.deviantart.net\\/avatars-big\\/c\\/h\\/chris.jpg?4","type":"admin","isWatching":false,"isSubscribed":false,"isNewDeviant":false},"media":{"baseUri":"https:\\/\\/images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com\\/f\\/178e6afa-0f9b-4ef0-bb15-47dadfa0e470\\/d465h2w-493c599a-9219-4fdf-9f3b-067003fc2d6d.jpg","prettyName":"steep_slope__stay_back_by_chris_d465h2w","token":["eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NjgzIiwicGF0aCI6IlwvZlwvMTc4ZTZhZmEtMGY5Yi00ZWYwLWJiMTUtNDdkYWRmYTBlNDcwXC9kNDY1aDJ3LTQ5M2M1OTlhLTkyMTktNGZkZi05ZjNiLTA2NzAwM2ZjMmQ2ZC5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.zP0wYRzbX8coJs6ldu7TaPY-vIal9B1Ao8a_tqvEWJE"],"types":[{"t":"150","r":0,"c":"v1\\/fit\\/w_150,h_150,q_70,strp\\/<prettyName>-150.jpg","h":100,"w":150},{"t":"200H","r":0,"c":"v1\\/fill\\/w_300,h_200,q_70,strp\\/<prettyName>-200h.jpg","h":200,"w":300},{"t":"300W","r":0,"c":"v1\\/fit\\/w_300,h_683,q_70,strp\\/<prettyName>-300w.jpg","h":200,"w":300},{"t":"250T","r":0,"c":"v1\\/fill\\/w_375,h_250,q_70,strp\\/<prettyName>-250t.jpg","h":250,"w":375},{"t":"350T","r":0,"c":"v1\\/fill\\/w_525,h_350,q_70,strp\\/<prettyName>-350t.jpg","h":350,"w":525},{"t":"400T","r":0,"c":"v1\\/fill\\/w_600,h_400,q_70,strp\\/<prettyName>-400t.jpg","h":400,"w":600},{"t":"preview","r":0,"c":"v1\\/fill\\/w_1024,h_683,q_75,strp\\/<prettyName>-fullview.jpg","h":683,"w":1024,"f":5288057},{"t":"social_preview","r":0,"c":"v1\\/fill\\/w_1024,h_683,q_75,strp\\/<prettyName>-fullview.jpg","h":683,"w":1024},{"t":"fullview","r":0,"c":"v1\\/fill\\/w_1024,h_683,q_75,strp\\/<prettyName>-fullview.jpg","h":683,"w":1024,"f":5288057}]}}}},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emoji":0,"emotes":0,"images":1,"mentions":0,"video":0,"previews":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":0,"chars":1}}]',
      },
    },
  },
  {
    deviationId: 888959427,
    type: 'status',
    typeId: 81,
    url: 'https://www.deviantart.com/redcapital3/status-update/Untitled-888959427',
    title: 'Untitled',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-08-16T04:53:10-0700',
    isTextEditable: true,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isPinned: false,
    isDailyDeviation: false,
    hasPrivateComments: false,
    blockReasons: [],
    author: {
      userId: 38167473,
      useridUuid: 'dca77dd8-7533-42d3-9969-7c9cbe87fc0d',
      username: 'redcapital3',
      usericon: 'https://a.deviantart.net/avatars-big/default.gif',
      usericonDefault: true,
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    media: {
      types: [],
    },
    textContent: {
      excerpt: '  ',
      html: {
        type: 'draft',
        features:
          '[{"type":"FIRST_IMAGE_FEATURE","data":[]},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emoji":0,"emotes":1,"images":0,"mentions":0,"video":0,"previews":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":0,"chars":2}}]',
      },
    },
  },
  {
    deviationId: 888959266,
    type: 'status',
    typeId: 81,
    url: 'https://www.deviantart.com/redcapital3/status-update/Untitled-888959266',
    title: 'Untitled',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-08-16T04:50:31-0700',
    isTextEditable: true,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isPinned: false,
    isDailyDeviation: false,
    hasPrivateComments: false,
    blockReasons: [],
    author: {
      userId: 38167473,
      useridUuid: 'dca77dd8-7533-42d3-9969-7c9cbe87fc0d',
      username: 'redcapital3',
      usericon: 'https://a.deviantart.net/avatars-big/default.gif',
      usericonDefault: true,
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    media: {
      types: [],
    },
    textContent: {
      excerpt: ' ',
      html: {
        type: 'draft',
        features:
          '[{"type":"FIRST_IMAGE_FEATURE","data":{"deviation":{"deviationId":595753605,"type":"image","typeId":1,"url":"https:\\/\\/www.deviantart.com\\/katie93611\\/art\\/Snivy-Sprite-595753605","title":"Snivy Sprite","isJournal":false,"isVideo":false,"isPurchasable":false,"isFavouritable":true,"publishedTime":"2016-03-10T07:11:57-0800","isShareable":true,"isCommentable":true,"isFavourited":false,"isDeleted":false,"isMature":false,"isDownloadable":false,"isAntisocial":false,"isBlocked":false,"isPublished":true,"isDailyDeviation":false,"hasPrivateComments":false,"author":{"userId":33946588,"useridUuid":"e100cd1e-0ba8-4782-a089-41c0ef6fd986","username":"katie93611","usericon":"https:\\/\\/a.deviantart.net\\/avatars-big\\/k\\/a\\/katie93611.gif?5","type":"regular","isWatching":false,"isSubscribed":false,"isNewDeviant":false},"media":{"baseUri":"https:\\/\\/images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com\\/i\\/e100cd1e-0ba8-4782-a089-41c0ef6fd986\\/d9up2f9-63f636e3-5690-4028-bdfb-2f4ec05ac9be.gif","token":["eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2UxMDBjZDFlLTBiYTgtNDc4Mi1hMDg5LTQxYzBlZjZmZDk4NlwvZDl1cDJmOS0xNGQxN2NkYy01ZDYyLTQ2OTgtYjM2ZC0wOTM2OWEzZTIyMmIuZ2lmIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.lNDPjlOwQMz1HOhhPsRGYcabuihNVuZxOUW2JpSguyQ"],"types":[{"t":"150","r":-1,"h":44,"w":48,"o":true},{"t":"200H","r":-1,"h":44,"w":48,"o":true},{"t":"300W","r":-1,"h":44,"w":48,"o":true},{"t":"250T","r":-1,"h":44,"w":48,"o":true},{"t":"350T","r":-1,"h":44,"w":48,"o":true},{"t":"400T","r":-1,"h":44,"w":48,"o":true},{"t":"preview","r":-1,"h":44,"w":48,"o":true,"f":30194},{"t":"social_preview","r":-1,"h":44,"w":48,"o":true},{"t":"fullview","r":-1,"h":44,"w":48,"o":true,"f":30194},{"t":"gif","r":0,"h":44,"w":48,"o":true,"f":30194,"b":"https:\\/\\/images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com\\/f\\/e100cd1e-0ba8-4782-a089-41c0ef6fd986\\/d9up2f9-14d17cdc-5d62-4698-b36d-09369a3e222b.gif"}]}}}},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emoji":0,"emotes":0,"images":1,"mentions":0,"video":0,"previews":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":0,"chars":1}}]',
      },
    },
  },
  {
    deviationId: 888958897,
    type: 'status',
    typeId: 81,
    url: 'https://www.deviantart.com/redcapital3/status-update/Untitled-888958897',
    title: 'Untitled',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-08-16T04:43:04-0700',
    isTextEditable: true,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isPinned: false,
    isDailyDeviation: false,
    hasPrivateComments: false,
    blockReasons: [],
    author: {
      userId: 38167473,
      useridUuid: 'dca77dd8-7533-42d3-9969-7c9cbe87fc0d',
      username: 'redcapital3',
      usericon: 'https://a.deviantart.net/avatars-big/default.gif',
      usericonDefault: true,
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    media: {
      types: [],
    },
    textContent: {
      excerpt: ' ',
      html: {
        type: 'draft',
        features:
          '[{"type":"FIRST_IMAGE_FEATURE","data":{"deviation":{"deviationId":681093532,"type":"image","typeId":1,"url":"https:\\/\\/www.deviantart.com\\/redcapital3\\/art\\/Bouquet2-681093532","title":"Bouquet2","isJournal":false,"isVideo":false,"isPurchasable":false,"isFavouritable":false,"publishedTime":"2017-05-17T07:10:08-0700","isShareable":true,"isCommentable":true,"isFavourited":false,"isDeleted":false,"isMature":false,"isDownloadable":true,"isAntisocial":false,"isBlocked":false,"isPublished":true,"isDailyDeviation":false,"hasPrivateComments":false,"author":{"userId":38167473,"useridUuid":"dca77dd8-7533-42d3-9969-7c9cbe87fc0d","username":"redcapital3","usericon":"https:\\/\\/a.deviantart.net\\/avatars-big\\/default.gif","usericonDefault":true,"type":"regular","isWatching":false,"isNewDeviant":false},"media":{"baseUri":"https:\\/\\/images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com\\/f\\/dca77dd8-7533-42d3-9969-7c9cbe87fc0d\\/db9i74s-64c3f862-eef5-4bdd-a62b-1fa936a0e7e9.jpg","prettyName":"bouquet2_by_redcapital3_db9i74s","token":["eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTYwIiwicGF0aCI6IlwvZlwvZGNhNzdkZDgtNzUzMy00MmQzLTk5NjktN2M5Y2JlODdmYzBkXC9kYjlpNzRzLTY0YzNmODYyLWVlZjUtNGJkZC1hNjJiLTFmYTkzNmEwZTdlOS5qcGciLCJ3aWR0aCI6Ijw9NjQwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.RqstsGvXV02dFv2OySDHTU2XD3khzE2SEfwfvMFBuV8","eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2RjYTc3ZGQ4LTc1MzMtNDJkMy05OTY5LTdjOWNiZTg3ZmMwZFwvZGI5aTc0cy02NGMzZjg2Mi1lZWY1LTRiZGQtYTYyYi0xZmE5MzZhMGU3ZTkuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.RhtZwOJ3E_MpgqVYinHM4aW5toiy_AZAttq7gqUjlHI"],"types":[{"t":"150","r":0,"c":"v1\\/fit\\/w_150,h_150,q_70,strp\\/<prettyName>-150.jpg","h":150,"w":100},{"t":"200H","r":0,"c":"v1\\/fill\\/w_133,h_200,q_70,strp\\/<prettyName>-200h.jpg","h":200,"w":133},{"t":"300W","r":0,"c":"v1\\/fit\\/w_300,h_900,q_70,strp\\/<prettyName>-300w.jpg","h":450,"w":300},{"t":"250T","r":0,"c":"v1\\/crop\\/w_167,h_250,x_0,y_0,scl_0.2609375,q_70,strp\\/<prettyName>-250t.jpg","h":250,"w":167},{"t":"350T","r":0,"c":"v1\\/fill\\/w_233,h_350,q_70,strp\\/<prettyName>-350t.jpg","h":350,"w":233},{"t":"400T","r":0,"c":"v1\\/crop\\/w_267,h_400,x_0,y_0,scl_0.4171875,q_70,strp\\/<prettyName>-400t.jpg","h":400,"w":267},{"t":"preview","r":0,"c":"v1\\/fill\\/w_640,h_960,q_75,strp\\/<prettyName>-fullview.jpg","h":960,"w":640,"f":287174},{"t":"social_preview","r":0,"c":"v1\\/fill\\/w_640,h_960,q_75,strp\\/<prettyName>-fullview.jpg","h":960,"w":640},{"t":"fullview","r":1,"h":960,"w":640,"f":287174}]},"entityId":681093532}}},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"MEDIA_COUNT_FEATURE","data":{"emoji":0,"emotes":0,"images":1,"mentions":0,"video":0,"previews":0}},{"type":"WORD_COUNT_FEATURE","data":{"words":0,"chars":1}}]',
      },
    },
  },
];
